import { useFloating as E, autoUpdate as P, useInteractions as V, useClick as C, useHover as F, useFocus as L, useRole as M, useDismiss as R, useId as S } from "@floating-ui/react";
import { useState as U, useCallback as _, useMemo as $ } from "react";
const v = 250, A = (t) => typeof t == "number" ? t : t ? v : 0;
function Y({
  open: t,
  defaultIsOpen: I,
  delay: y,
  placement: O = "bottom",
  triggerEvent: a = "click",
  onOpenChange: n,
  middlewares: h = [],
  strategy: k,
  role: c = "dialog",
  disableOpenOnFocus: D
}) {
  const [w, x] = U(!!I), o = t ?? w, s = _(
    (g) => {
      x(g), n && n(g);
    },
    [n]
  ), { context: e, refs: r, x: u, y: i, strategy: l, middlewareData: d } = E({
    open: o,
    onOpenChange: s,
    placement: O,
    strategy: k,
    middleware: h,
    whileElementsMounted: P
  }), p = V([
    C(e, { enabled: a === "click" }),
    F(e, {
      enabled: a === "hover",
      delay: { open: A(y) }
    }),
    L(e, { enabled: !D }),
    M(e, { role: c }),
    R(e, { enabled: c !== "tooltip" })
  ]), m = S(), b = `${m}-label`, f = `${m}-description`;
  return $(
    () => ({
      ...p,
      context: e,
      descriptionId: f,
      refs: r,
      labelId: b,
      middlewareData: d,
      open: o,
      setOpen: s,
      strategy: l,
      x: u,
      y: i
    }),
    [p, e, f, r, b, d, o, s, l, u, i]
  );
}
export {
  Y as usePopover
};
//# sourceMappingURL=usePopover.js.map
